import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Info from '../../Info';
import DropdownClassic from "../../../components/DropdownClassic"

// Import utilities
import { tailwindConfig } from '../../../utils/Utils';

function TopCategoriesCard({title, category, data, hint, palette}) {

  const [barData, setBarData] = useState([]);
  const palettes = [['bg-pink-100', 'bg-yellow-100'], ['bg-green-100', 'bg-cyan-100'],
    ['bg-purple-100', 'bg-rose-100'], ['bg-lime-100', 'bg-sky-100']]

  const [colors, setColors] = useState(palettes[0])

  useEffect(() => {

    if(palette!==undefined)
      setColors(palettes[palette])

    setBarData(data.map((item, index) => {
      return (
        <li className="relative px-2 py-1">
          <div className={`absolute inset-0 ${index%2===0?colors[0]:colors[1]}`} aria-hidden="true" style={{width: item.fill}}></div>
          <div className="relative flex justify-between space-x-2">
            <div>{item.category}</div>
            <div className="font-medium">{item.fill}</div>
          </div>
        </li>
      );
    }))
  }, [data, palette]);

  return (
    <div className="bg-white p-5 shadow-1 rounded-sm border border-slate-200 w-full">
      <header className="px-5 py-4 border-b border-slate-100 flex items-center">
        <h2 className="font-semibold text-slate-800">{title}</h2>
        <Info className="ml-auto" containerClassName="min-w-80">
          <div className="text-sm">{hint}</div>
        </Info>
      </header>
      <div className="grow p-3">
        <div className="flex flex-col h-full">
          {/* Card content */}
          <div className="grow">
            <ul className="flex justify-between text-xs uppercase text-slate-400 font-semibold px-2 space-x-2">
              <li>{category}</li>
              <li># Campaigns</li>
            </ul>
            {barData.length===0?
              <div className="sm:flex justify-items-center w-full mt-4">
                <div className="m-auto text-center">
                  <svg className="animate-spin h-5 w-full" viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="6" fill="transparent" strokeLinecap="round"
                            strokeDasharray="283" strokeDashoffset="75"/>
                  </svg>
                </div>
              </div>:
              <ul className="space-y-1 text-sm text-slate-800 mt-3">
                {barData}
              </ul>
            }
          </div>
          {/* Card footer */}
          {/*<div className="text-center pt-4 pb-1 border-t border-slate-100">
            <Link className="text-sm font-medium text-yellow-500 hover:text-yellow-600" to="#0">Channels Report -&gt;</Link>
          </div>*/}
        </div>
      </div>
    </div>
  );
}

export default TopCategoriesCard;
